/**
 * ERP Financial API client for fetching the full group hierarchy.
 * @see https://erp.fms.ogintegration.us/docs/api/group-hierarchy#get-group-hierarchy
 */

import { baseErpRequest } from './erpRequest';
import type { ErpApiError } from './types';

export type GroupHierarchyNode = {
  groupId: number;
  parentGroupId: number | null;
  name: string;
  displayNameOnReport: string;
  description: string;
  code: string | null;
  type: 'PARENT' | 'LEAF';
  active: boolean;
  level: number;
  hasChildren: boolean;
};

export type GroupHierarchyResponse = {
  message: string;
  statusCode: number;
  data: {
    rootGroupId: number;
    groups: GroupHierarchyNode[];
  };
  errors?: ErpApiError[] | null;
};

export type GetGroupHierarchyParams = {
  groupId: number;
};

export const getGroupHierarchy = async (
  { groupId }: GetGroupHierarchyParams,
  clientOptions: RequestInit = {},
  hostUrl?: string
): Promise<GroupHierarchyResponse> => {
  return (await baseErpRequest(`/groups/${encodeURIComponent(groupId)}/hierarchy`, clientOptions, hostUrl)
    .get()
    .json()) as GroupHierarchyResponse;
};
